module.exports = __webpack_public_path__ + "static/media/LaGarza.98a062a9.png";